(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"), require("module-common-abc"), require("module-mobile-utils"));
	else if(typeof define === 'function' && define.amd)
		define(["base", "core", "ui", "module-common-abc", "module-mobile-utils"], factory);
	else if(typeof exports === 'object')
		exports["widget-manage-password-abc"] = factory(require("base"), require("core"), require("ui"), require("module-common-abc"), require("module-mobile-utils"));
	else
		root["widget-manage-password-abc"] = factory(root["base"], root["core"], root["ui"], root["module-common-abc"], root["module-mobile-utils"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict'; /**
	               *  ----------------------------------------------------------------
	               *  Copyright © Backbase B.V.
	               *  ----------------------------------------------------------------
	               *  Filename : main.js
	               *  Description: Some description
	               *  ----------------------------------------------------------------
	               */

	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {

	    'use strict';

	    module.name = 'widget-manage-password-abc';

	    // External Dependencies
	    var base = __webpack_require__(3);
	    var core = __webpack_require__(4);
	    var ui = __webpack_require__(5);
	    var common = __webpack_require__(6);
	    var mobileUtils = __webpack_require__(7);

	    // Internal Dependencies
	    var Model = __webpack_require__(8);
	    var MainCtrl = __webpack_require__(9);

	    var deps = [
	    core.name,
	    ui.name,
	    common.name,
	    mobileUtils.name];


	    /**
	                        * @ngInject
	                        */
	    function run(lpCoreBus, lpWidget, lpConstants) {
	        if (lpWidget && lpWidget.model) {
	            lpCoreBus.publish(lpConstants.PUBLISH.CXP_ITEM_LOADED, {
	                id: lpWidget.model.name });

	            if (window.cxp && window.cxp.mobile) {
	                lpCoreBus.publish(lpConstants.PUBLISH.BB_ITEM_LOADED, { id: lpWidget.id });
	            }
	        }
	    }

	    module.exports = base.createModule(module.name, deps).
	    controller('MainCtrl', MainCtrl).
	    factory('model', Model).
	    run(run);
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict'; /**
	               * Models
	               * @module models
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	    'use strict';

	    /**
	                   * @constructor
	                   * @ngInject
	                   */
	    function WidgetModel(lpWidget, lpCoreUtils, lpPortal, $resource) {
	        var utils = lpCoreUtils;
	        var countryCode = lpWidget.getPreference('countryCode');
	        var state = {
	            title: lpWidget.getPreference('title'),
	            icon: utils.resolvePortalPlaceholders(lpWidget.getPreference('thumbnailUrl')),
	            changePasswordUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('changePasswordUrl')) || lpPortal.root + '/services/rest/v1/password',
	            changeForgotPasswordUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('changeForgotPasswordUrl')) || lpPortal.root + '/services/rest/v1/forget-password',
	            checkPasswordComplexityUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('checkPasswordComplexityUrl')) || lpPortal.root + '/services/rest/v1/public/password/validate-complexity',
	            userPortfolioInfoUrl: lpCoreUtils.resolvePortalPlaceholders(lpWidget.getPreference('userPortfolioInfoUrl')) || lpPortal.root + '/services/rest/v1/portfolio' };


	        var model = {};
	        /**
	                         * @public
	                         * @return {Object} current model state
	                         */
	        model.getState = function () {
	            return state;
	        };

	        model.userPortfolioInfo = $resource(state.userPortfolioInfoUrl);
	        model.changePasswordUpdate = $resource(state.changePasswordUrl, '@payload', {
	            put: {
	                method: 'PUT' } });


	        model.changePasswordSave = $resource(state.changePasswordUrl);

	        model.changePasswordComplexity = $resource(state.checkPasswordComplexityUrl);
	        model.changeForgotPassword = $resource(state.changeForgotPasswordUrl);

	        return model;
	    }

	    module.exports = WidgetModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict"; /**
	               * Controllers
	               * @module controllers
	               */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports) {

	  'use strict';

	  /**
	                 * Main controller
	                 * @ngInject
	                 * @constructor
	                 */
	  function MainCtrl($scope, model, lpPortal, lpCoreBus, lpCoreUtils, $window, lpConstants, MobileAlertService, CommonService, TranslateService) {

	    var self = this;
	    var CTRL_CONSTANTS = {
	      "SHOW_OLD_PASSWORD_VIEW": "showOldPasswordView",
	      "SHOW_NEW_PASSWORD_VIEW": "showNewPasswordView",
	      "NEW_PASSWORD": "Reset Password",
	      "CHANGE_PASSWORD": "Change Password" };

	    self.isValid = false;
	    self.modalWindowOpen = false;
	    self.isSuccess = false;
	    self.isFail = false;
	    self.errorCode = '';
	    self.isServerError = false;
	    self.isActiveUser = false;
	    self.isOldPassword = true;
	    self.isNewPassword = false;
	    self.isConfirmPassword = false;
	    self.changePasswordPayload = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: '' };

	    self.passwordRegex = lpConstants.REGEX.PASSWORD;
	    self.alreadyHavingPassword = 1;

	    /* --- Error Messages ---*/
	    self.serverError = TranslateService.translate("abc.common.server.error");
	    self.passwordError = TranslateService.translate("abc.common.password.validation.rules");
	    self.passwordServerError = TranslateService.translate("abc.common.error.oops");
	    self.successMessage = TranslateService.translate("abc.common.password.changed");
	    self.passwordCompareError = TranslateService.translate("abc.manage_password.confirm.password.error.message");
	    self.passwordComplexityError = TranslateService.translate("abc.manage_password.complexity.rules.message");
	    self.isMobileNative = window.cxp && window.cxp.mobile ? true : false;

	    self.toggleChangePasswordView = toggleChangePasswordView;

	    if (self.isMobileNative) {
	      lpCoreBus.subscribe(lpConstants.SUBSCRIBE.JSON_DATA, function (payload) {
	        self.managePasswordFlow = payload.status;
	        if (payload.status == lpConstants.COMMON.CHANGE_PASSWORD) {
	          self.alreadyHavingPassword = 1;
	          CommonService.toggleTitlebar(true, CTRL_CONSTANTS.CHANGE_PASSWORD);
	          self.toggleChangePasswordView(CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW);
	        } else {
	          self.bindingStatus = payload.bindingStatus || 0;
	          self.alreadyHavingPassword = 0;
	          CommonService.toggleTitlebar(true, CTRL_CONSTANTS.NEW_PASSWORD);
	          self.toggleChangePasswordView(CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW);
	        }
	      });
	      lpCoreBus.publish(lpConstants.PUBLISH.JSON_SEND);
	    } else {
	      //Web pub-sub
	      lpCoreBus.subscribe('launchpad-retail.changePassword', function (payload) {
	        self.managePasswordFlow = payload.status;
	        if (payload.status === lpConstants.COMMON.CHANGE_PASSWORD) {
	          self.bindingStatus = 0;
	          self.isOldPassword = true;
	        } else {
	          self.bindingStatus = payload.bindingStatus;
	          self.isOldPassword = false;
	        }
	      });

	    }

	    self.redirectToLogin = function () {
	      self.isMobileNative ? gadgets.pubsub.publish(lpConstants.PUBLISH.SIGNOUT) : $window.location.href = lpPortal.root + '/' + lpPortal.name + '/sign-in';
	    };

	    self.logoutSession = function () {
	      self.modalWindowOpen = false;
	      logout();
	    };

	    self.hideModalWindow = function () {
	      self.isSuccess = false;
	      self.isFail = false;
	      self.isServerError = false;
	      self.modalWindowOpen = false;
	      angular.element($("div[data-pid^='bg-container']")).removeAttr('style');
	    };

	    self.allowDoNext = function () {
	      var result = false;
	      if (self.isOldPassword) {
	        result = self.changePasswordPayload.oldPassword &&
	        self.changePasswordPayload.newPassword &&
	        self.changePasswordPayload.confirmPassword &&
	        self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword &&
	        new RegExp(self.passwordRegex).test(self.changePasswordPayload.confirmPassword);
	      } else {
	        result = self.changePasswordPayload.newPassword &&
	        self.changePasswordPayload.confirmPassword &&
	        self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword &&
	        new RegExp(self.passwordRegex).test(self.changePasswordPayload.confirmPassword);
	      }
	      return result;
	    };

	    self.validatePattern = function (event) {
	      self.isValid = false;
	      var pattern = self.passwordRegex;
	      var val = angular.element(event.target).val();
	      if (val.length == 0) {
	        self.isValid = true;
	        return true;
	      }
	      var returnVal = new RegExp(pattern).test(val);
	      if (returnVal) {
	        self.isValid = true;
	        return true;
	      } else
	      {
	        self.isValid = false;
	        return false;
	      }
	    };

	    self.comparePassword = function () {
	      return self.changePasswordPayload.confirmPassword === self.changePasswordPayload.newPassword;
	    };

	    self.managePassword = function () {
	      if (self.managePasswordFlow === lpConstants.COMMON.LOGIN_FIRST_TIME || self.managePasswordFlow === lpConstants.COMMON.CHANGE_PASSWORD) {
	        self.updatePassword();
	      } else {
	        self.readyToResetPassword();
	      }
	    };
	    self.checkComplexity = function () {
	      //TODO only if password is valid
	      if (self.isValid) {
	        self.isConfirmPassword = true;
	        self.isNewPassword = false;
	      } else {
	        showNativeAlert(self.passwordComplexityError, clearFields, null, true);
	      }
	    };
	    function clearFields() {
	      self.changePasswordPayload.confirmPassword = '';
	      self.changePasswordPayload.newPassword = '';
	      $scope.$apply();
	    }
	    self.allowToSubmitOtp = function () {
	      if ($("#txtForgotOtp").val().toString() !== '' && $("#txtForgotOtp").val().toString().length === 6) {
	        angular.element('#submitForgotOtp').focus();
	        return true;
	      } else {
	        return false;
	      }
	    };

	    self.closeWindow = function () {
	      self.otpWindowOpen = false;
	      self.clearOtp();
	    };

	    self.clearOtp = function () {
	      self.otp = null;
	      $("#txtForgotOtp").val('');
	    };

	    self.updatePassword = function () {
	      if (self.isMobileNative) {
	        var comparePass = self.comparePassword();
	        if (!comparePass) {
	          handleInvalidNewPassword();
	          return;
	        }
	      }
	      var payload = {
	        "oldPassword": self.changePasswordPayload.oldPassword,
	        "newPassword": self.changePasswordPayload.newPassword };

	      self.alreadyHavingPassword === 0 ? delete payload.oldPassword : angular.noop;
	      if (self.managePasswordFlow === lpConstants.COMMON.SET_PASSWORD) {
	        delete payload.oldPassword;
	        model.changePasswordSave.save(payload).$promise.then(function (success) {
	          self.isSuccess = true;
	          self.isFail = false;
	          self.isServerError = false;
	          CommonService.toggleTitlebar(false);
	          if (self.alreadyHavingPassword === 0) {
	            nextStep();
	          } else {
	            showModalWindow();
	          }
	        }, function (error) {
	          self.isSuccess = false;
	          self.isServerError = error.data.errors && error.data.errors.length > 0 && error.data.errors[0].code === lpConstants.CUSTOM_ERROR_CODES.SERVER_ERROR;
	          self.isFail = !self.isServerError;
	          showException(self.isServerError, error.data);
	        });
	      } else if (self.managePasswordFlow === lpConstants.COMMON.CHANGE_PASSWORD) {
	        model.changePasswordUpdate.put(payload).$promise.then(function (success) {
	          self.isSuccess = true;
	          self.isFail = false;
	          self.isServerError = false;
	          CommonService.toggleTitlebar(false);
	          if (self.alreadyHavingPassword === 0) {
	            nextStep();
	          } else {
	            showModalWindow();
	          }
	        }, function (error) {
	          self.isSuccess = false;
	          self.isServerError = error.data.errors && error.data.errors.length > 0 && error.data.errors[0].code === lpConstants.CUSTOM_ERROR_CODES.SERVER_ERROR;
	          self.isFail = !self.isServerError;
	          showException(self.isServerError, error.data);
	        });
	      }
	    };
	    function showException(isServerError, response) {
	      if (isServerError) {
	        if (self.isMobileNative) {
	          CommonService.serverErrorAlert(logout);
	          return;
	        } else
	        {
	          self.errorMessage = self.passwordServerError;
	        }
	      } else
	      if (response.errorMessages && response.errorMessages.length > 0) {
	        self.errorMessage = response.errorMessages[0].errorMessage;
	      } else
	      {
	        self.errorMessage = self.passwordServerError;
	      }
	      self.isMobileNative ? handleInvalidOldPassword(self.errorMessage) : showModalWindow();
	    }
	    function nextStep() {
	      lpCoreBus.publish(lpConstants.PUBLISH.LOAD_SUB_PAGE, { 'relationship': 'Child', 'target': lpConstants.PAGE.VERIFICATION_METHODS, 'jsonData': {} });
	    }

	    function handleInvalidOldPassword(error) {
	      self.changePasswordPayload = {
	        oldPassword: '',
	        newPassword: '',
	        confirmPassword: '' };

	      showNativeAlert(error, self.toggleChangePasswordView, CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW, true);
	    }

	    function handleInvalidNewPassword() {
	      self.changePasswordPayload.newPassword = '';
	      self.changePasswordPayload.confirmPassword = '';
	      showNativeAlert(self.passwordCompareError, self.toggleChangePasswordView, CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW, true);
	    }

	    function toggleChangePasswordView(view, outOfContext) {
	      self.isOldPassword = view === CTRL_CONSTANTS.SHOW_OLD_PASSWORD_VIEW;
	      self.isNewPassword = view === CTRL_CONSTANTS.SHOW_NEW_PASSWORD_VIEW;
	      self.isConfirmPassword = false;
	      outOfContext ? $scope.$apply() : angular.noop();
	    }

	    function showNativeAlert(message, callBack, callBackParam, context) {
	      var buttons = [MobileAlertService.getOkButton()];
	      buttons[0].callback = function () {if (callBack) callBack(callBackParam, context);};
	      MobileAlertService.show(message, buttons);
	    }

	    function showModalWindow() {
	      self.modalWindowOpen = true;
	      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
	    }
	    function showOTPWindow() {
	      self.otpWindowOpen = true;
	      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
	    }

	    function logout() {
	      CommonService.logout();
	    }
	    self.submitOtp = function () {
	      self.otp = '' + self.otp;
	      self.otpWindowOpen = false;
	      var payload = {
	        "newPassword": self.changePasswordPayload.newPassword,
	        "otp": $("#txtForgotOtp").val() };

	      changePassword(payload);
	    };

	    function showConfirmationWindow() {
	      self.confirmationWindowOpen = true;
	      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
	    }

	    self.closeConfirmationWindow = function () {
	      self.confirmationWindowOpen = false;
	      angular.element($("div[data-pid^='bg-container']")).removeAttr('style');
	      logout();
	    };

	    //Methods for forgotpassword flow
	    self.presubmitValidation = function () {
	      var payload = {
	        "password": self.changePasswordPayload.newPassword };


	      model.changePasswordComplexity.save(payload).$promise.then(function (success) {
	        if (self.isMobileNative) {
	          lpCoreUtils.showOtpWindow(function (otp) {
	            self.otpMobile = otp.data;
	            var payload = {
	              "newPassword": self.changePasswordPayload.newPassword,
	              "otp": otp && otp.data ? otp.data : '' };

	            changePassword(payload);
	          });
	        } else {
	          //Need to do with binding status
	          //self.bindingStatus === 0 ? changePassword({newPassword: self.changePasswordPayload.newPassword}) : showOTPWindow();
	          self.bindingStatus === 0 ? self.updatePassword() : showOTPWindow();
	        }
	      }, function (error) {
	        self.isSuccess = false;
	        if (error.data.errorMessage) {
	          showValidationWindow(error.data.errorMessage, true);
	          self.button = 'abc.common.button.close';
	        } else {
	          showValidationWindow(self.passwordServerError, false);
	          self.button = 'abc.common.end.session';
	        }
	      });
	    };

	    self.readyToResetPassword = function () {
	      var comparePass = self.comparePassword();
	      if (comparePass) {
	        self.presubmitValidation();
	      } else {
	        handleInvalidNewPassword();
	      }
	    };

	    function changePassword(payload) {
	      model.changeForgotPassword.save(payload).$promise.then(function (success) {
	        self.isSuccess = true;
	        CommonService.toggleTitlebar(false);
	        self.isFailure = false;
	        !self.isMobileNative ? showConfirmationWindow() : angular.noop;
	      }, function (error) {
	        self.isSuccess = false;
	        self.isFailure = true;
	        if (error && error.data && error.data.errorMessage) {
	          self.errorMessage = error.data.errorMessage;
	        }
	        if (self.isMobileNative) {
	          var buttons = [{
	            type: lpConstants.MOBILE_SDK_BUTTONS.POSITIVE,
	            text: TranslateService.translate("abc.common.button.ok"),
	            callback: logout }];

	          MobileAlertService.show(self.errorMessage, buttons);
	        } else {showConfirmationWindow();}
	      });
	    }

	    function showValidationWindow(errorMessage, serverError) {
	      self.passwordError = true;
	      self.serverError = serverError;
	      self.errorMessage = errorMessage;
	      angular.element($("div[data-pid^='bg-container']")).attr('style', 'overflow:visible');
	    }

	  }

	  MainCtrl.prototype.$onInit = function () {
	    // Do initialization here
	  };

	  module.exports = MainCtrl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// widget-manage-password-abc.js